import { render, staticRenderFns } from "./Columns.vue?vue&type=template&id=93339e5e&scoped=true&"
import script from "./Columns.vue?vue&type=script&lang=ts&"
export * from "./Columns.vue?vue&type=script&lang=ts&"
import style0 from "./Columns.vue?vue&type=style&index=0&id=93339e5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93339e5e",
  null
  
)

export default component.exports